// Prefix an absolute in-app path with the Vite base (e.g. '/real-estate/').
//
// React Router's <Link>/useNavigate already prepend the basename, but raw
// hand-built <a href="/..."> anchors do NOT — the browser treats them as
// site-absolute and drops the base prefix, so under a subpath deploy they
// navigate outside the app (/roleplay/x instead of /real-estate/roleplay/x)
// and white-screen. Any hand-built internal href must run through appHref().
//
// BASE_URL is '/real-estate/' under path routing, '/' for a root build.
const BASE = import.meta.env.BASE_URL.replace(/\/+$/, ''); // -> '/real-estate' or ''

export const appHref = (path: string): string => BASE + (path.startsWith('/') ? path : `/${path}`);
